import b2tLogo from "../images/logo.png"

/** B2T logo used when a profile/company image is missing or fails to load */
export const DEFAULT_PROFILE_IMAGE = b2tLogo

export const resolveProfileImage = (src) => src || DEFAULT_PROFILE_IMAGE

export const isUsableProfileImage = (src) =>
  Boolean(src) && src !== DEFAULT_PROFILE_IMAGE

export const handleProfileImageError = (event) => {
  const img = event?.currentTarget || event?.target
  if (!img) return

  img.onerror = null
  img.src = DEFAULT_PROFILE_IMAGE
}
